import { Scrollbar, Carousel_CoreInit, Popup } from './core'
import Header from './modules/header'
import Locator from './modules/locator'
import Cart from './modules/cart'
import './modules/cart-form'
import './modules/product'
import './modules/product-card'
import './plugins/embed-container'
import './plugins/ingredient-list'
import './plugins/product-content'
import './plugins/table-of-content'
import './plugins/stories'
import './plugins/form'
import './plugins/quiz'
import './plugins/product-policies'

$(function() {
  /* Header */
  Header.init()

  /* Locator */
  Locator.init()

  /* Popup */
  Popup.init()

  /* Cart */
  Cart.init()

  $('.grid:not(.grid--disabled-link) .card-ingredient').each(function() {
    $(this).toggleDescription();
  })

  $('.grid:not(.grid--disabled-link) .card-ingredient-list').each(function() {
    $(this).toggleDescriptionList();
  })

  $('.grid:not(.grid--disabled-link) .card-product').each(function() {
    $(this).toggleProductContent();
  })

  $('.js-ingredients-display-grid').each(function() {
    $(this).toggleGridDisplays('.js-ingredients-results');
  })

  $('.ingredients-header__categories').each(function() {
    $(this).filterIngredients('.js-ingredients-results');
  })

  $('.story-header__categories').each(function() {
    $(this).filterStories('.js-story-results');
  })

  $('.js-anchor-menu-container').each(function() {
    $(this).stickyTableOfContent('.js-anchor-menu');
  })

  $('.single-product .js-anchor-menu').each(function() {
    $(this).linkTableOfContent('.product-category__grid');
  })

  /* Fade-in elements */
  $('.fade-in, .slide-in').each(function() {
    $(this).FadeIn()
  })

  /* Make videos look like images */
  $('.video-loop').each(function() {
    let self = $(this)
    let video = $(this).find('video')
    if (video.data('loaded')) {
      setTimeout(function() {
        picture(video.get(0))
        video.get(0).play()
      }, 60)
    } else {
      video.on('canplaythrough', function() {
        picture(video.get(0))
        video.get(0).play()
      })
    }
  })

  /* Embed container with play button */
  $('.embed-container').each(function() {
    $(this).EmbedContainer()
  })

  /* Forms */
  $('.newsletter-form').each(function() {
    $(this).NewsletterForm()
  })

  /* Quiz */
  $('.melia-quiz').each(function() {
    $(this).Quiz()
  })

  /* Quiz Page */
  $('.quiz-page').each(function() {
    $(this).QuizPage()
  })

  /* Core Carousels */
  window.Carousel_CoreBeforeInit = function(carousel) {
    if (carousel.find('.grid--style--header').length) {
      carousel.swiper_options.spaceBetween = 0
      carousel.swiper_options.pagination.renderBullet = function(index, className) {
        return '<div class="' + className + '">' + (index + 1) + '</div>'
      }
    }
  }
  Carousel_CoreInit([
    {
      classSelector: 'carousel--use-scrollbar',
      swiperOptions: {
        mousewheel : {releaseOnEdges: true, forceToAxis: true,},
      },
    },
  ])

  /* Back to top */
  $('.back-to-top').on('click', function() {
    $('html, body').scrollTo(0, 350, 4, 'easeInOutQuart')
  })
  const scrollEvents = $(window).ScrollEvents()
  let scrolledDown = false,
  topArrow = $('.back-to-top').BlockElement()
  scrollEvents.add(function(top) {
    if (!scrolledDown && top > $('body').height() * .25 && top > $(window).height()) {
      scrolledDown = true
      topArrow.addModifier('visible')
      $('body').addClass('--scroll-top-visible')
    } else if (scrolledDown && top < $(window).height() / 2) {
      scrolledDown = false
      topArrow.removeModifier('visible')
      $('body').removeClass('--scroll-top-visible')
    }
  })

  /* Copy page URL */
  let copiedTimeout = undefined
  $('.post-share__action--copy-link').on('click', function() {
    let self = $(this)
    self.find('textarea').val(window.location.href).focus().select()
    document.execCommand("Copy")
    self.find('span').addClass('visible').text(melia_l10n.COPIED_LINK)
    clearTimeout(copiedTimeout)
    copiedTimeout = setTimeout(function() {
      self.find('span').removeClass('visible')
    }, 3200)
  })

  /* Fix content */
  $('.post-share').each(function() {
    let fixedContent = $(this).FixedContent({
      topBlocker: $('.header-wrapper'),
      bottomBlocker: $('.page-section--read-more'),
      container: $('.single-article__share'),
      mobile: false,
    })
  })

  /* Products */
  $('body.single-product').each(function() {
    $(this).Product()
  })

  /* Product cards */
  $('.card-product').each(function() {
    $(this).ProductCard()
  })

  /* Filtered grid */
  $('.grid--reordered').each(function() {
    $(this).ReorderedGrid()
  })

  /* Checkout */
  $('.js-policies').each(function() {
    $(this).productPolicies()
  })

  // var cart_scrollbar = new Scrollbar('.cart-panel__content', {
  //   direction: 'vertical',
  //   desktop: true,
  //   mobile: true,
  // })

  var menu_scrollbar = new Scrollbar('.header__mobile-menu', {
    direction: 'vertical',
    desktop: false,
    mobile: true,
  })
})
